"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const componentAttributes_1 = require("../../dataStructures/entities/componentAttributes");
const getComponentText = (element) => {
    const textOverride = element.getAttribute('data-snowplow-component-text');
    let text = null;
    if (textOverride !== null) {
        text = textOverride;
    }
    else {
        text = element.innerText;
    }
    if (text === null || text === undefined || text === '') {
        const img = element.querySelector('img');
        if (img !== null) {
            text = img.alt;
            if (text === null || text === undefined || text === '') {
                return null;
            }
        }
        else {
            return null;
        }
    }
    // Trim leading/trailing whitespace and truncate to MAX_LABEL_CHARS
    const trimmed = text.trim();
    if (trimmed === '') {
        return null;
    }
    return trimmed.length > componentAttributes_1.MAX_LABEL_CHARS ? trimmed.slice(0, componentAttributes_1.MAX_LABEL_CHARS) : trimmed;
};
exports.default = getComponentText;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0Q29tcG9uZW50VGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91dGlscy9keW5hbWljQ29udGV4dC9nZXRDb21wb25lbnRUZXh0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsMkZBQW9GO0FBRXBGLE1BQU0sZ0JBQWdCLEdBQUcsQ0FBQyxPQUFvQixFQUFpQixFQUFFO0lBQzdELE1BQU0sWUFBWSxHQUFHLE9BQU8sQ0FBQyxZQUFZLENBQUMsOEJBQThCLENBQUMsQ0FBQztJQUMxRSxJQUFJLElBQUksR0FBOEIsSUFBSSxDQUFDO0lBQzNDLElBQUksWUFBWSxLQUFLLElBQUksRUFBRTtRQUN2QixJQUFJLEdBQUcsWUFBWSxDQUFDO0tBQ3ZCO1NBQU07UUFDSCxJQUFJLEdBQUcsT0FBTyxDQUFDLFNBQVMsQ0FBQztLQUM1QjtJQUVELElBQUksSUFBSSxLQUFLLElBQUksSUFBSSxJQUFJLEtBQUssU0FBUyxJQUFJLElBQUksS0FBSyxFQUFFLEVBQUU7UUFDcEQsTUFBTSxHQUFHLEdBQUcsT0FBTyxDQUFDLGFBQWEsQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUN6QyxJQUFJLEdBQUcsS0FBSyxJQUFJLEVBQUU7WUFDZCxJQUFJLEdBQUcsR0FBRyxDQUFDLEdBQUcsQ0FBQztZQUNmLElBQUksSUFBSSxLQUFLLElBQUksSUFBSSxJQUFJLEtBQUssU0FBUyxJQUFJLElBQUksS0FBSyxFQUFFLEVBQUU7Z0JBQ3BELE9BQU8sSUFBSSxDQUFDO2FBQ2Y7U0FDSjthQUFNO1lBQ0gsT0FBTyxJQUFJLENBQUM7U0FDZjtLQUNKO0lBRUQsbUVBQW1FO0lBQ25FLE1BQU0sT0FBTyxHQUFHLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztJQUM1QixJQUFJLE9BQU8sS0FBSyxFQUFFLEVBQUU7UUFDaEIsT0FBTyxJQUFJLENBQUM7S0FDZjtJQUNELE9BQU8sT0FBTyxDQUFDLE1BQU0sR0FBRyxxQ0FBZSxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsRUFBRSxxQ0FBZSxDQUFDLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQztBQUMxRixDQUFDLENBQUM7QUFFRixrQkFBZSxnQkFBZ0IsQ0FBQyJ9


// WEBPACK FOOTER //
// ../../../../src/utils/dynamicContext/getComponentText.ts